import React from 'react'
import "./Footer.css"

const clearData = ()=> {
    localStorage.clear();
}

export const Footer = () => {
  return (
    <div id="footer">
        <center><p>Copyright &copy; 2022 | Expenses Tracker</p></center>
        <a onClick={clearData}>Clear all Data</a>
    </div>
  )
}
